import { useEffect, useRef, useState } from 'react';

const useTimeoutTyping = (defaultText = '', milliseconds) => {
  const [text, setText] = useState(defaultText);
  const [isTyping, setIsTyping] = useState(false);

  const timeout = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      setIsTyping(true);
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      timeout.current = setTimeout(() => {
        setIsTyping(false);
        clearTimeout(timeout.current);
        timeout.current = null;
      }, milliseconds);
    } else {
      isMounted.current = true;
    }

    return () => {
      setIsTyping(false);
    };
  }, [text]);

  return [text, setText, isTyping];
};

export default useTimeoutTyping;
